import React from "react";
import { MessageCircle } from "lucide-react";

const WHATSAPP_LINK = "https://wa.me/5511917611575?text=Olá! Gostaria de uma consulta jurídica.";

const WhatsAppFloat = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Fale conosco pelo WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <div className="bg-green-500 hover:bg-green-600 p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110">
        <MessageCircle className="w-8 h-8 text-white" />
      </div>
    </a>
  );
};

export default WhatsAppFloat;
